import { Actions } from '../actions/index';

export function dictionaryReducer(state = null, action:any):any {
  switch (action.type) {
    case Actions.FETCH_DICTIONARY:
      return action.payload.data;
  }
  return state;
}
